import React from 'react';
import PropTypes from 'prop-types';
import CircularProgress from '@material-ui/core/CircularProgress';
import { withStyles } from '@material-ui/core/styles';
import './styles.css';

const styles = theme => ({
    progress: {
        margin: theme.spacing.unit * 2,
    },
    loaderLight: {
        color: theme.palette.primary.light,
    },
    loaderDark: {
        color: theme.palette.primary.main,
    },
});

const getWrapperClass = (isInline, isInlineCover) => {
    if (isInline) {
        return 'inline-loading-container-wrapper';
    } else if (isInlineCover) {
        return 'loading-container-wrapper inline-cover';
    }
    return 'loading-container-wrapper';
};

const getLoaderClass = (isInline, isInlineCover) => {
    if (isInline) {
        return 'inline-loading-container';
    } else if (isInlineCover) {
        return 'loading-container inline-cover';
    }
    return 'loading-container';
};

const LoadingWrapper = ({ children, isInline, isInlineCover }) => (
    <div className={getWrapperClass(isInline, isInlineCover)}>
        <div className={getLoaderClass(isInline, isInlineCover)}>{children}</div>
    </div>
);

LoadingWrapper.propTypes = {
    children: PropTypes.object,
    isInline: PropTypes.bool,
    isInlineCover: PropTypes.bool,
};

const Loading = props => {
    if (props.error) {
        return (
            <LoadingWrapper isInline={props.isInline} isInlineCover={props.isInlineCover}>
                <p>Something went wrong!</p>
            </LoadingWrapper>
        );
    }
    if (props.timedOut) {
        return (
            <LoadingWrapper isInline={props.isInline} isInlineCover={props.isInlineCover}>
                <div className={props.isInline ? 'text-center' : 'text-center mt-5'}>
                    <CircularProgress
                        className={`props.classes.progress ${props.isInline ? props.classes.loaderDark : props.classes.loaderLight}`}
                        size={70}
                    />
                </div>
            </LoadingWrapper>
        );
    }
    if (props.pastDelay) {
        return (
            <LoadingWrapper isInline={props.isInline} isInlineCover={props.isInlineCover}>
                <span>
                    <div className="dot" />
                    <div className="dot" />
                    <div className="dot" />
                </span>
            </LoadingWrapper>
        );
    }
    return null;
};

Loading.propTypes = {
    error: PropTypes.bool,
    timedOut: PropTypes.bool,
    pastDelay: PropTypes.bool,
    isInline: PropTypes.bool,
    isInlineCover: PropTypes.bool,
    classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(Loading);
